import { useNavigate } from "react-router-dom";
import { useAuth } from "@shared";
import { Button } from "@printtat/ui";

export const Dashboard = () => {
  const navigate = useNavigate();
  const { user, loading, error } = useAuth();

  // Automatically redirect to sign-in if no user is found
  if (!loading && !user) {
    navigate("/sign-in", { replace: true });
    return null;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-red-600 text-xl mb-4">Error</div>
          <p className="text-gray-600 mb-4">{error}</p>
          <Button
            onClick={() => navigate("/sign-in")}
            color="blue"
          >
            Go to Sign In
          </Button>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
   <div>
   </div>
  );
};

// Named export only — no default export
